import { PartialBrief } from "../../../../Types/Brief"

const isBizPlatform = ({ guest }: PartialBrief) => (
  (guest?.isBusinessUser && guest?.country !== 'AU') ?? false
)

export default isBizPlatform
